import React from 'react';
import {
    Button
} from 'react-bootstrap';
import Axios from 'axios';
import Configs from '../../../Configs';

class MoreGrabFoodConfigurationsButton extends React.PureComponent {

    state = {
        uploading: false,
        promoting: false,
        getting: false,
        openPopup: false,
        spot: {}
    };

    componentDidMount() {
       
    }

    uploadHandler = () => {
        const object = this.props.object;
        const controller = object.controller;
        this.setState({
            uploading: true
        })
        Axios.post(`${Configs.backendUrl}/management/update?controller=${controller}`).then(res => {
            this.setState({
                uploading: false
            })
        }).catch(err => {
            this.setState({
                uploading: false
            })
        })
    }

    promoteHandler = () => {
        const object = this.props.object;
        const controller = object.controller;
        this.setState({
            promoting: true
        })
        Axios.post(`${Configs.backendUrl}/management/promote?controller=${controller}`).then(res => {
            this.setState({
                promoting: false
            })
        }).catch(err => {
            this.setState({
                promoting: false
            })
        })
    }

    getHandler = () => {
        const object = this.props.object;
        const controller = object.controller;
        this.setState({
            getting: true
        })
        Axios.get(`${Configs.backendUrl}/management/get?controller=${controller}`).then(res => {
            this.setState({
                getting: false,
                openPopup: true
            }, () => {
                const data = {...res.data};
                this.setState({
                    spot: {...data}
                })
            })
        }).catch(err => {
            this.setState({
                getting: false
            })
        })
    }

    closePopupHandler = () => {
        this.setState({
            openPopup: false,
        })
    }

    render () {
        return (
            <React.Fragment>
                {
                    !this.state.uploading ? (
                        <Button variant="primary pull-right" onClick={() => this.uploadHandler()}>
                            <i className="fa fa-cloud-upload"></i>
                            <span className="hidden-xs hidden-sm">&nbsp;Upload Spot</span>
                        </Button>
                    ) : (
                        <Button variant="primary pull-right" disabled>
                            <i className="fa fa-spinner fa-spin"></i>
                            <span className="hidden-xs hidden-sm">&nbsp;Uploading Spot</span>
                        </Button>
                    )
                }
                {
                    !this.state.promoting ? (
                        <Button variant="success pull-right" onClick={() => this.promoteHandler()}>
                            <i className="fa fa-send-o"></i>
                            <span className="hidden-xs hidden-sm">&nbsp;Promote Spot</span>
                        </Button>
                    ) : (
                        <Button variant="success pull-right" disabled>
                            <i className="fa fa-spinner fa-spin"></i>
                            <span className="hidden-xs hidden-sm">&nbsp;Promoting Spot</span>
                        </Button>
                    )
                }
                {
                    !this.state.getting ? (
                        <Button variant="default pull-right" onClick={() => this.getHandler()}>
                            <i className="fa fa-send-o"></i>
                            <span className="hidden-xs hidden-sm">&nbsp;Get Spot</span>
                        </Button>
                    ) : (
                        <Button variant="default pull-right" disabled>
                            <i className="fa fa-spinner fa-spin"></i>
                            <span className="hidden-xs hidden-sm">&nbsp;Getting Spot</span>
                        </Button>
                    )
                }
                {
                    this.state.openPopup ? (
                        <div className="MoreButtonPopup">
                            <div className="popup_image_bover">
                            </div>
                            <div className="popup_image form-popup">
                                <div className="form-container">
                                    <div className="popup_header">
                                        <h3 className="pull-left">Spot Information from Google</h3>
                                    </div>
                                    <div className="popup_body">
                                        <div className="col-md-12 col-xs-12 col-lg-12">
                                            <div className="form-group">
                                                <textarea className="form-control" rows="16" value={JSON.stringify(this.state.spot, undefined, 4)} disabled></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="popup_footer">
                                        <div className="row">
                                            <div className="col-xs-12 col-md-12 col-lg-12 buttonFooter">
                                                <button className="btn btn-default btn-block" onClick={this.closePopupHandler}>Close</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : null
                }
            </React.Fragment>
        )
    }
}

export default MoreGrabFoodConfigurationsButton;